import { Box, Checkbox } from "@mui/material";
import { NewCampaignContext } from "contexts/NewCampaign";
import { useContext } from "react";
import { CampaignBrand } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

interface Props {
  campaignBrand: CampaignBrand | undefined;
  totalBrands: number;
  handleOpenDeleteDialog?: () => void;
}
const UncheckBrand = ({
  campaignBrand,
  totalBrands,
  handleOpenDeleteDialog,
}: Props) => {
  const { excludedBentoBrandIds, setExcludedBentoBrandIds } =
    useContext(NewCampaignContext);

  const checked =
    campaignBrand?.bentoBrand?.id &&
    !excludedBentoBrandIds?.has(campaignBrand?.bentoBrand?.id);

  const handleChange = (e: CustomEvent) => {
    e.stopPropagation();
    if (!campaignBrand || !campaignBrand.bentoBrand.id) return;

    setExcludedBentoBrandIds((prev) => {
      const copy = new Set(prev);
      if (copy.has(campaignBrand.bentoBrand.id)) {
        copy.delete(campaignBrand.bentoBrand.id);
      } else {
        if (totalBrands <= 1 && handleOpenDeleteDialog) {
          handleOpenDeleteDialog();
          return copy;
        }
        copy.add(campaignBrand.bentoBrand.id);
      }
      return copy;
    });
  };
  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <Checkbox checked={Boolean(checked)} onChange={handleChange} />
    </Box>
  );
};

export default UncheckBrand;
